@if (listing) {
  <div
    class="wrap">
    <!-- top text section-->
    @if (content) {
      <div class="center p-b-14 p-t-4-s p-t-4-m p-b-4-s p-b-4-m"
        >
        <p class="o1 col-6 uppercase"
        *iCms="'subtitle' of content"></p>
        <p class="m-t m-t-3-s hero"
        *iCms="'title' of content"></p>
        <div>
          <p class="m-t p1 w-8 w-12-s"
          *iCms="'text' of content"></p>
        </div>
      </div>
    }
    <!-- S grid selector -->
    <div *ifSize="'S'"
      class="right m-t-12 m-b-7">
      <i [ngClass]="gridS === 1 ? 'col-1' : 'col-4'"
        class="icon-grid-1 m-r"
      (click)="gridS = 1;"></i>
      <i [ngClass]="gridS === 2 ? 'col-1' : 'col-4'"
        class="icon-grid-2"
      (click)="gridS = 2;"></i>
    </div>
    <!-- images -->
    <div class="m-t-6 m-t-3-s m-t-3-m m-b-3-s m-b-3-m">
      <!-- image list -->
      <div [grid]="[gridS, 2, 3, 3][client.sizeId]"
        [gridColumnGap]="4"
        [gridRowGap]="4">
        @for (model of modelsWithoutDuplicates; track model; let index = $index) {
          <div
            class="pos-relative cursor-pointer"
            iCmsModalOpen="image-zoom-modal"
            [iCmsModalOpenData]="model.data.image">
            <!-- image -->
            <div class="overflow-hidden"
              [ngClass]="client.isS && gridS === 1 ? 'ratio-4-5' : 'ratio-1-1'">
              <local-shell />
              <img class="rf"
                [image]="model.data.image"/>
            </div>
            <!-- overlay -->
            @if (!(client.isS && gridS === 2)) {
              <div
                class="fill"
                style="background: rgba(0, 0, 0, 0.15);">
              </div>
            }
            <!-- profile name -->
            @if (model.data?.user_tag) {
              <p [ngClass]="client.isS && gridS === 2 ? 'p2 m-t-2 w-12' : 'pos-absolute col-w bottom-6 bottom-5-s left-5 right-0 p1'"
                >{{client.isS && gridS === 2 && model.data?.user_tag.length > 19 ?
              model.data?.user_tag.substring(0,19) + '...' : model.data?.user_tag}}</p>
            }
          </div>
        }
      </div>
    </div>
    <!-- view more and qty viewed -->
    @if (listing.getTotal() > content.infScrollStep) {
      <div class="p-t-20 m-t-1 center"
        >
        <!-- number of viewed elements  -->
        <p class="p1 col-1">{{ 'You’ve viewed % of % homes' | translate : listing.visibleQty :
        listing.getTotal() }}</p>
        <!-- view more button -->
        @if (listing.hasMore) {
          <button class="button bg-col-w p-r-5 p-l-5 b-a b-col-1 m-t-5"
            role="button"
            (click)="increaseLimit()"
          [attr.aria-label]="'View more' | translate">{{'View more' | translate}}</button>
        }
      </div>
    }
    <!-- no items info -->
    <p
      class="w-10 w-12-m w-11-s col-11 m-t-10-m m-t-10-s p-b-8-s p1"
      *iCms="'message' of content; content: 'html'; skipEmpty: true"
    ></p>
  </div>
}
